<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat
            color="transparent">
            <v-card-text
              class="py-0">
              <v-row
                align="center"
                justify="center"
                style="height: 100vh; overflow-y: auto;">
                <v-col
                  cols="12">
                  <div
                    class="text-center">
                    <div>
                      <div
                        class="title font-weight-bold text-capitalize mb-8">
                        Hai, Selamat {{ isDay }}
                      </div>

                      <div
                        class="text-h4 font-weight-bold black--text">
                        {{ dateNow | time }}
                      </div>

                      <div
                        class="mb-8">
                        {{ dateNow | date }}
                      </div>

                      <div
                        class="font-weight-bold">
                        Ensiklopedia Tanaman
                      </div>

                      <v-divider
                        class="my-2 mx-12"
                        style="border-top: 1px dashed #bbbbbb" />

                      <div
                        class="mb-16">
                        Dinas Lingkungan Hidup
                      </div>
                    </div>

                    <div
                      id="app">
                      <div 
                        id="qr-code-full-region">
                      </div>

                      <!-- <div
                        v-for="(msg, index) in message"
                        :key="index"
                        style="white-space: pre-line">
                        <pre>decodedResult => {{ msg.decodedResult }}</pre>
                      </div> -->
                    </div>

                    <v-btn v-if="!qrcode"
                      @click="startScan()"
                      fab
                      width="200"
                      height="200"
                      style="box-shadow: rgb(16, 156, 87, 0.2) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;">
                      <v-avatar
                        size="175">
                        <v-img 
                          contain
                          width="100%"
                          height="100%"
                          alt="ensiklopediatanaman" 
                          :src="require('@/assets/icon/qr_code.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-btn>

                    <div>  
                      <a v-if="!qrcode"
                        :href="`https://maps.google.com/?q=${center.latitude},${center.longitude}`"
                        target="_blank"
                        class="d-flex align-center justify-center mt-6 mb-2">
                        <v-icon size="18" color="blue">mdi-map-marker-radius</v-icon>
                        
                        <span
                          class="blue--text ml-1">
                          Lokasi Anda Terkini
                        </span>
                      </a>

                      <div
                        class="body-1 font-weight-bold mt-16 mb-6">
                        Informasi Alur
                      </div>

                      <v-row>
                        <v-col
                          cols="4">
                          <v-avatar
                            tile
                            size="45">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="ensiklopediatanaman" 
                              :src="require('@/assets/icon/step_1.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    size="20" 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <div
                            class="caption mt-4">
                            Cari atau pilih tanaman yang akan di scan
                          </div>
                        </v-col>

                        <v-col
                          cols="4">
                          <v-avatar
                            tile
                            size="45">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="ensiklopediatanaman" 
                              :src="require('@/assets/icon/step_2.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    size="20" 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <div 
                            class="caption mt-4">
                            Silahkan scan QR kode yang terdapat di tanaman
                          </div>
                        </v-col>

                        <v-col
                          cols="4">
                          <v-avatar
                            tile
                            size="45">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="ensiklopediatanaman" 
                              :src="require('@/assets/icon/step_3.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    size="20" 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <div 
                            class="caption mt-4">
                            Akan muncul data mengenai tanaman tersebut
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  import { Html5QrcodeScanner, html5QrCode } from 'html5-qrcode'
  export default {
    middleware: false,
    data () {
      return {
        dateNow: new Date(),
        center: {
          latitude: null,
          longitude: null
        },

        qrcode: false,
        html5QrcodeScanner: null,
        config: {
          fps: 10, 
          qrbox: 200
        },

        message: [],
        lastResult: {},

        // SEO
        content: {
          url: '/',
          title: 'Scan QR Kode',
          description: 'Scan QR Kode Ensiklopedia Tanaman',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.member.auth.user
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.reset()
    },
    methods: {
      reset () {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
        })
      },

      startScan () {
        this.qrcode = true

        if (this.qrcode) {
          this.html5QrcodeScanner = new Html5QrcodeScanner(
            'qr-code-full-region',
            this.config
          )
  
          this.html5QrcodeScanner.render(this.onScanSuccess)
        }
      },
      onScanSuccess (decodedText, decodedResult) {
        const obj = { decodedResult: decodedResult }

        this.message.push(obj)

        let domain = 'https://kehati.klaten.go.id'

        window.location.href = `${decodedText.split(domain)[1]}`
      }
    }
  }
</script>

<style>
  #qr-code-full-region {
    border-radius: 10px;
  }

  #qr-code-full-region__scan_region {
    border-radius: 10px;
  }

  #qr-shaded-region {
    border-radius: 10px 10px 0px 0px;
  }

  #qr-code-full-region img {
    display: none;
  }
</style>